import getUrlForEnv, {services} from "@irati/utils/endpoints/getUrlForEnv"

const endpoints = {
  createOnboarding: () => getUrlForEnv(services.ONBOARDING_SERVICE, "/v2/onboarding")
}

export default endpoints
